var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtility4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.846 2.25153L40.5703 0.119189C40.1699 -0.0795396 39.6939 -0.0278704 39.3456 0.256311L25.8365 10.6077L31.4375 15.0969L38.6007 9.8807V26.1386L22.5908 13.281L6.58087 0.423242C6.23068 0.143035 5.75667 0.0913664 5.35812 0.290095L1.15394 2.39065C0.755385 2.58937 0.5 3.0067 0.5 3.46378V32.6769C0.5 33.1338 0.75345 33.5512 1.15394 33.7499L5.43164 35.8804C5.83213 36.079 6.30807 36.0274 6.65633 35.7432L19.0625 24.8194L13.4615 20.3302L7.4012 26.1168V9.99994L39.4036 35.7253C39.7538 36.0055 40.2278 36.0572 40.6264 35.8584L45.5 33.422V3.32268C45.5 2.86561 45.2465 2.44828 44.846 2.24955V2.25153Z",
    fill: "#37ABFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility4);
export default __webpack_public_path__ + "static/media/utility4.6992c6617ff412ae94c0579a5be561d8.svg";
export { ForwardRef as ReactComponent };